import React, {Component} from 'react'
import HighlightKeywordCell from '../../FunctionArea/HighlightKeywordCell'
import {server_ip} from '../../../ipAddress'


class QuestionCaseRecordContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            queryCaseID:null,
            queryCaseMainInfo:null,
            queryCaseDialog:null
        }
    }

    componentDidMount(){  
        this.initialQueryCaseID()
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.queryCaseID !== this.state.queryCaseID)
        {
            this.refreshQueryCaseInfo()
        }
    }

    componentWillUnmount(){
    }

    initialQueryCaseID=()=>{
        if(this.props.queryCaseID && this.props.queryCaseID !== this.state.queryCaseID)
        {
            this.setState({
                queryCaseID:this.props.queryCaseID
            })
        }
    }

    refreshQueryCaseInfo=()=>{
        this.getQueryCaseMainInfo()
        this.getQueryCaseDialog()
        
    }

    getQueryCaseMainInfo=async()=>{
        if(this.state.queryCaseID)
        {
            let msg = await fetch(server_ip+'/api/QA/QuestionCase/Detail/ID/'+this.state.queryCaseID)
            let output = await msg.json()
            console.log("getQueryCaseDetail")
            console.log(output[0])
            if(output[0])
            {
                this.setState({
                    queryCaseMainInfo:output[0]
                })
            }
        }
    }

    getQueryCaseDialog=async()=>{
        if(this.state.queryCaseID)
        {
            let msg = await fetch(server_ip+'/api/QA/QuestionCase/Dialog/ID/'+this.state.queryCaseID)
            let output = await msg.json()
            console.log("getQueryCaseDetail")
            console.log(output)
            if(output[0])
            {
                this.setState({
                    queryCaseDialog:output
                })
            }
        }
    }

    getEncodeFormBody=(formObject)=>{
        let formBody =[]
        for (let property in formObject) 
        {
            let encodedKey = encodeURIComponent(property);
            let encodedValue = encodeURIComponent(formObject[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        return formBody
    }
    
    createQuestionCaseDetailSection=()=>{
        if(this.state.queryCaseMainInfo)
        {
            return(   
                <div>      
                    <div className={"QuestionCaseRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>案件名稱</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_Title} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>案件種類</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_Type} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>來訪者IP</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_VisitorIP} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>來訪者ID</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_VisitorID} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>來訪者姓名</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_VisitorName} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>來訪者信箱</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_VisitorEmail} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>案件承辦</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_CaseOfficer} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>處理狀態</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_Status} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>案件起案時間</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_OpenTime} keywords={this.props.keywords}/></div>
                        </div>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>案件結案時間</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={this.state.queryCaseMainInfo.Query_Case_CloseTime} keywords={this.props.keywords}/></div>
                        </div>                  
                    </div>
                </div>
            )
        }
        else
        {
            return null
        }
    }

    createQuestionCaseDialogSection=()=>{
        if(this.state.queryCaseDialog)
        {
            return (
            <div className={"MovieRecordStaffSection"}>
                {this.getDialogList()}
            </div>)
        }
        else
        {
            return null
        }
    }

    getDialogList=()=>{
        let result = this.state.queryCaseDialog.map((row,index)=>{
            //if(row.Movie_StaffName || row.Movie_Company)
            //{
                if(index !==0)
                {  
                    return( 
                    <div className={"MovieRecordContainerCell"}>
                        <div className={"MovieRecordContainerCellRow"}>
                            <div className={"MovieRecordContainerCellTitle"}>{row.ID}</div>
                            <div className={"MovieRecordContainerCellNormalField"}><HighlightKeywordCell text={row.Query_EmitMessage} keywords={this.props.keywords}/></div>
                        </div>  
                    </div>
                    )
                }
                else
                {
                    return null
                }
            //}
        })
        return result
    }

    

    render(){
        let recordContainerStyle = {
            width:'100%',
            height:'100%',
            position:'absolute',
            backgroundColor:"#ffffff80",
            zIndex:"2000",   
        }

        let innerContainerStyle = {
            width:'90%',
            maxHeight:"700px",
            position:'relative',
            backgroundColor:"white",
            border:"1px solid black",
            margin:"auto",
            overflowY:"scroll",
            top:"50px",
            borderRadius:"5px",
            boxShadow:"0px 0px 10px 0px black"          
        }


        return(
            <div style={recordContainerStyle}>   
                <div style={innerContainerStyle}>
                    <div className ={"rightTopBoxArea"}>
                        <div className = {"rightTopBox"} onClick={()=>this.props.closeModal()}>{"X"}</div>             
                    </div>
                    {this.createQuestionCaseDetailSection()}
                    {this.createQuestionCaseDialogSection()}
                </div>         
            </div>
        )
    }
}

export default QuestionCaseRecordContainer